import { render, staticRenderFns } from "./TradeNews0.vue?vue&type=template&id=20afeaed&scoped=true&"
import script from "./TradeNews0.vue?vue&type=script&lang=js&"
export * from "./TradeNews0.vue?vue&type=script&lang=js&"
import style0 from "./TradeNews0.vue?vue&type=style&index=0&id=20afeaed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20afeaed",
  null
  
)

export default component.exports